import { SERVER_URL } from '../../environment';

// Single source of truth for the endpoint. The backend (inkblot-services,
// POD2-2117 slice 3) must expose this route and validate `session_token`
// against the appointment's issued Vonage token. Matches inkblot-web.
export const CALL_OUTCOME_PATH = '/api/video_call_outcomes';

// Sends one call-outcome record via fetch(..., { keepalive: true }) so it
// survives in-app navigation away from the call as well as tab-close/unload.
//
// We deliberately do NOT use navigator.sendBeacon: sendBeacon always issues the
// request with credentials mode "include", and the browser forbids a wildcard
// `Access-Control-Allow-Origin: *` response on a credentialed cross-origin
// request. The Practice client (inkblotpractice.com) and the API
// (inkblottherapy.com) are cross-origin and the API answers with `*`, so every
// sendBeacon was silently blocked by CORS (sendBeacon still returns true — it
// only reports that the request was queued, not delivered) and no outcome was
// ever recorded. fetch with `credentials: 'omit'` makes the wildcard acceptable;
// `keepalive: true` preserves the survives-teardown guarantee. Auth is not a
// user credential here — it travels in the body as session_token (the Vonage
// client JWT). Payload contains no PII/PHI. Returns true if the request was
// dispatched for delivery.
export const reportCallOutcome = report => {
  try {
    if (typeof fetch !== 'function') {
      return false;
    }

    const url = `${SERVER_URL}${CALL_OUTCOME_PATH}`;

    const payload = {
      appointment_id: report.appointmentId,
      vonage_session_id: report.vonageSessionId,
      session_token: report.sessionToken,
      outcome: report.outcome,
      reason: report.reason,
      had_reconnect: report.hadReconnect,
      time_to_connect_ms: report.timings.timeToConnectMs,
      time_to_two_way_audio_ms: report.timings.timeToTwoWayAudioMs,
      remote_connection_seen: report.remoteConnectionSeen,
      remote_stream_seen: report.remoteStreamSeen,
      publish_succeeded: report.publishSucceeded,
      role: report.role,
    };

    // Fire-and-forget: teardown must not await the network, and a rejected
    // request (offline, blocked) must never surface into the calling cleanup.
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'omit',
      keepalive: true,
    }).catch(() => undefined);

    return true;
  } catch {
    // Telemetry must never break the calling teardown path.
    return false;
  }
};
